<template>
  <fragment>
    <AppBody
      title="Eventos / Gerenciar"
      :subtitle="pageSubtitle"
      :actions="pageActions"
    >
      <v-form @submit.prevent="filterEvents" class="search-forms">
        <v-row>
          <v-col cols="3">
            <label class="input-labels"> Descrição do produto </label>
            <v-text-field
              solo
              placeholder="Ex: Bilhete"
              v-model="filter.descricao"
              type="text"
              data-cy="descricao"
              class="textinput"
            ></v-text-field>
          </v-col>
          <!-- <v-col cols="3">
            <label class="input-labels"> SKU </label>
            <v-text-field
              solo
              placeholder="Digite o SKU do produto"
              v-model="$produtos_gerenciar.filter.sku"
              type="text"
              class="textinput"
            ></v-text-field>
          </v-col> -->
          <v-col cols="3">
            <label class="input-labels">Categoria</label>
            <v-select
              height="48"
              :items="$produtos_gerenciar.categorias_produtos"
              @click:clear="filter.categoria = ''"
              clearable
              clear-icon="mdi-close-circle-outline"
              dense
              solo
              data-cy="Status"
              class="textinput"
              v-model="filter.idcategoria"
              item-text="descricao"
              item-value="idcategoria"
              placeholder="Selecione a categoria"
            ></v-select>
          </v-col>
          <v-col cols="3">
            <label class="input-labels">Status</label>
            <v-select
              height="48"
              :items="$produtos_gerenciar.status_produtos"
              @click:clear="filter.status = ''"
              clearable
              clear-icon="mdi-close-circle-outline"
              dense
              solo
              data-cy="Status"
              class="textinput"
              v-model="filter.status"
              item-text="value"
              item-value="key"
              placeholder="Selecione o status"
            ></v-select>
          </v-col>
          <v-col cols="3">
            <label class="input-labels"> Canal de Vendas </label>
            <v-select
              :items="filtredSalesChannel"
              @click:clear="filter.canal_venda = ''"
              clearable
              v-model="filter.canal_venda"
              height="48"
              dense
              solo
              data-cy="canal-vendas"
              class="textinput"
              item-text="value"
              item-value="key"
              placeholder="Selecione o Canal de Vendas"
              clear-icon="mdi-close-circle-outline"
            ></v-select>
          </v-col>
          <v-col cols="2" class="align-self-end ml-auto">
            <v-btn
              height="48"
              data-cy="filtrar"
              class="button btn-size btn-border"
              type="submit"
              >Filtrar</v-btn
            >
          </v-col>
        </v-row>
      </v-form>
      <v-data-table
        class="table-body"
        no-data-text="Não há registro de produtos para esta loja."
        loading-text="Buscando informações..."
        :loading="eventsLoading"
        :headers="headersProdutos"
        :items="tableValues"
        :items-per-page="10"
        :footer-props="{
          itemsPerPageOptions: [10, 20, 50],
          itemsPerPageText: 'Produtos por página:',
        }"
      >
        <template v-slot:item.ins_dthr="{ item }">
          {{ item.ins_dthr | dthr_pt_br }}
        </template>
        <template v-slot:item.action="{ item }" class="table-actions">
          <div style="display: flex; justify-content: center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-switch
                  :color="$config.dados.corinputs"
                  v-bind="attrs"
                  v-on="on"
                  block
                  :label="
                    item.tipo_taxa_web == 'CONVENIENCIA'
                      ? 'Conveniência'
                      : 'Comissão'
                  "
                  dense
                  v-model="item.tipo_taxa_web"
                  inset
                  @click="$produtos_gerenciar.reverterTaxa(item.idproduto)"
                  true-value="CONVENIENCIA"
                  false-value="COMISSAO"
                  persistent-hint
                >
                </v-switch>
              </template>
            </v-tooltip>
          </div>
        </template>
        <template v-slot:item.actions="{ item, index }" class="table-actions">
          <div style="display: flex; justify-content: center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :color="$config.dados.corinputs"
                  height="30"
                  width="30"
                  small
                  :disabled="item.variantes.variacoes_produto.length == 0"
                  icon
                  v-bind="attrs"
                  v-on="on"
                  @click="
                    openModal('modal-body-variacoes-detalhes', item.variantes)
                  "
                  class="mr-2"
                >
                  <v-icon>mdi-book-open-outline</v-icon>
                </v-btn>
              </template>
              <span>Variações</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :color="$config.dados.corinputs"
                  height="30"
                  width="30"
                  small
                  icon
                  v-bind="attrs"
                  v-on="on"
                  @click="
                    $produtos_gerenciar.duplicarProduto(
                      storeSequencial,
                      item.idproduto,
                      'duplicar',
                      index
                    )
                  "
                  class="mr-2"
                >
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </template>
              <span>Duplicar Produto</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :color="$config.dados.corinputs"
                  height="30"
                  width="30"
                  small
                  icon
                  v-bind="attrs"
                  v-on="on"
                  @click="
                    $produtos_gerenciar.getProdutoById(item.idproduto, 'editar')
                  "
                  class="mr-2"
                >
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :color="$config.dados.corinputs"
                  height="30"
                  class="mr-2"
                  :disabled="item.libera_acesso_disable"
                  v-bind="attrs"
                  v-on="on"
                  width="30"
                  small
                  icon
                  @click="$produtos_gerenciar.sendToProductLoja(item.slug)"
                >
                  <v-icon>mdi-open-in-new</v-icon>
                </v-btn>
              </template>
              <span>Acessar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :color="$config.dados.corinputs"
                  height="30"
                  v-bind="attrs"
                  v-on="on"
                  width="30"
                  small
                  icon
                  @click="
                    $produtos_gerenciar.remover(
                      item.idproduto,
                      'Deseja realmente excluir este produto?'
                    )
                  "
                >
                  <v-icon> mdi-delete-outline </v-icon>
                </v-btn>
              </template>
              <span>Deletar</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
      <ModalVariacoesDetalhes />
      <ModalConfirmacao
        :textModal="$produtos_gerenciar.text"
        @callback="$produtos_gerenciar.funcaoRemover"
      />
    </AppBody>
  </fragment>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import dayjs from "dayjs";
import products from "@/mixins/products.js";
import _ from "lodash";

export default {
  name: "Events",
  metaInfo: {
    title: "Eventos | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Eventos | ElevenTickets",
      },
    ],
  },
  components: {
    ModalVariacoesDetalhes: () =>
      import(
        "@/components/produtos/gerenciar/variants/modal-variacoes-detalhes.vue"
      ),
    AppBody: () => import("@/layouts/components/AppBody.vue"),
    ModalConfirmacao: () => import("@/components/global/modal-confirmacao.vue"),
  },
  props: {},
  mixins: [products],
  data() {
    return {
      actions: [
        {
          name: "Criar evento",
          action: () => this.$produtos_gerenciar.getProdutoById("", "new"),
        },
        {
          name: "Ordenação",
          action: () =>
            this.$router.push({
              name: "order",
            }),
        },
      ],
      actionsLojista: [
        {
          name: "Criar evento",
          action: () => this.$produtos_gerenciar.getProdutoById("", "new"),
        },
        {
          name: "Ordenação",
          action: () =>
            this.$router.push({
              name: "order",
            }),
        },
      ],
      dayjs,
      filter: {
        descricao: "",
        idcategoria: "",
        status: "",
        canal_venda: "",
      },
    };
  },
  computed: {
    ...mapGetters(["storeSequencial", "allEvents", "eventsLoading"]),
    filtredSalesChannel() {
      return this.$produtos_gerenciar.canal_venda.filter(
        item => item.value !== "Cortesia"
      );
    },
    pageSubtitle() {
      if (this.$produtos_gerenciar.loja_prod)
        return "Eventos - " + this.$produtos_gerenciar.loja_prod;
      return "Eventos";
    },
    pageActions() {
      if (this.$axios.getLocal("oe_user_info").data.user_type === "admin")
        return this.actions;
      return this.actionsLojista;
    },
    tableValues() {
      if (this.allEvents.length > 0) {
        this.allEvents.forEach(prod => {
          switch (prod.canal_venda) {
            case "PDV_POS;ECOMMERCE;IFRAME;LINK":
              prod.canal_venda = "Venda POS + Web";
              break;
            case "PDV_POS":
              prod.canal_venda = "Venda POS";
              break;
            case "ECOMMERCE;IFRAME;LINK":
            case "ECOMMERCE;IFRAME":
              prod.canal_venda = "Venda Web";
              break;
            case "PDV_POS;ECOMMERCE;IFRAME":
              prod.canal_venda = "Venda POS + Web";
              break;
            case "CORTESIA":
              prod.canal_venda = "Cortesia";
              break;
            default:
              break;
          }
          prod.descricao = this.$config.convertTagString(prod.descricao);
          prod.estoque = prod.qtd_estoque || prod.qtd_estoque_var || 0;

          if (prod.status == "ATIVO") {
            if (prod.dthr_termino === "1969-12-31 21:00:00") {
              prod.libera_acesso_disable = false;
            } else if (dayjs().isAfter(dayjs(prod.dthr_termino))) {
              prod.libera_acesso_disable = true;
            } else if (prod.gerenciar_estoque == 1) {
              if (prod.estoque > 0) {
                prod.libera_acesso_disable = false;
              } else {
                prod.libera_acesso_disable = true;
              }
            } else if (prod.gerenciar_estoque == 0) {
              prod.libera_acesso_disable = false;
            } else {
              prod.libera_acesso_disable = true;
            }
          } else {
            prod.libera_acesso_disable = true;
          }
        });
        return _.orderBy(this.allEvents, "ins_dthr", "desc");
      } else {
        return [];
      }
    },
  },
  methods: {
    ...mapActions(["fetchEvents"]),
    openModal(name, item) {
      this.$produtos_gerenciar.cadastro.variacoes.variacoes_produtos =
        item.variacoes_produto;
      document.getElementsByClassName(name)[0].style.display = "flex";
    },

    filterEvents() {
      let filters = [];
      if (this.filter.descricao) {
        filters.push({
          campo: "prod.descricao",
          tipo: "string",
          orientacao: "like",
          valor: this.filter.descricao,
        });
      }

      if (this.filter.idcategoria) {
        filters.push({
          campo: "prod.idcategoria",
          tipo: "string",
          valor: this.filter.idcategoria,
        });
      }

      if (this.filter.status) {
        filters.push({
          campo: "prod.status",
          tipo: "string",
          valor: this.filter.status,
        });
      }

      if (this.filter.canal_venda) {
        filters.push({
          campo: "prod.canal_venda",
          tipo: "string",
          valor: this.filter.canal_venda,
        });
      }

      this.fetchEvents({
        producerId: this.storeSequencial,
        ...filters,
      });
    },
  },
  mounted() {
    this.$produtos_gerenciar.getStatusProdutos();
    this.$produtos_gerenciar.getTiposProdutos();
    this.$produtos_gerenciar.getProdutosCategoria();
    this.$produtos_gerenciar.getCanaisVenda();
    this.fetchEvents({ producerId: this.storeSequencial, filtro: [] });
  },
  destroyed() {
    this.$produtos_gerenciar.limpaFiltros();
    this.$produtos_gerenciar.produtos = [];
  },
};
</script>

<style scoped>
.table-actions {
  height: 67px !important;
  min-height: 67px !important;
  margin-bottom: 0px !important;
}

.produtos-gerenciar-button1 {
  color: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
  display: flex;
  padding: 0px;
  align-items: center;
  border-width: 0px;
  margin-right: 10px;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}

.produtos-gerenciar-button2 {
  color: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
  display: flex;
  padding: 0px;
  position: relative;
  align-items: center;
  border-width: 0px;
  margin-right: 10px;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}

.produtos-gerenciar-button3 {
  color: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
  display: flex;
  padding: 0px;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}
</style>
